import { Box } from '@mui/material';

interface IProps {
  children: React.ReactNode;
}

function EventCompletionFooter({ children }: IProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
      }}
    >
      {children}
    </Box>
  );
}

export default EventCompletionFooter;
